import { FiArrowLeft, FiArrowRight } from "react-icons/fi";

type NavigationButtonsProps = {
  currentStep: number;
  canProceed: boolean;
  onPrevious: (e?: React.MouseEvent) => void;
  onNext: (e?: React.MouseEvent) => void;
  onSkip: (e?: React.MouseEvent) => void;
  onClose: () => void;
  onFindMatches: (e?: React.MouseEvent) => void;
};

export const NavigationButtons = ({
  currentStep,
  canProceed,
  onPrevious,
  onNext,
  onSkip,
  onClose,
  onFindMatches,
}: NavigationButtonsProps) => {
  return (
    <div className="flex flex-col sm:flex-row gap-3 justify-end">
      <button
        type="button"
        onClick={(e) => {
          e?.preventDefault();
          e?.stopPropagation();
          if (currentStep === 1) {
            onClose();
          } else {
            onPrevious(e);
          }
        }}
        disabled={currentStep === 1}
        className={`flex items-center justify-center gap-2 rounded-lg border-2 px-4 sm:px-6 py-2.5 sm:py-3 text-xs sm:text-sm font-termina font-medium transition-colors ${
          currentStep === 1
            ? 'border-[#D1D5DB] bg-[#F5F5F5] text-[#9CA3AF] cursor-not-allowed'
            : 'border-[#E5E7EB] bg-white text-[#6B7280] hover:bg-[#F9FAFB]'
        }`}
      >
        <FiArrowLeft className="h-4 w-4" />
        Previous
      </button>
      {currentStep < 4 ? (
        <>
          {/* Skip button for steps 1-3 */}
          {currentStep <= 3 && (
            <button
              type="button"
              onClick={(e) => {
                e?.preventDefault();
                e?.stopPropagation();
                onSkip(e);
              }}
              className="flex items-center justify-center gap-2 rounded-lg border-2 border-[#026857] bg-white px-4 sm:px-6 py-2.5 sm:py-3 text-xs sm:text-sm font-termina font-medium text-[#026857] transition-colors hover:bg-[#026857]/5"
            >
              Skip
            </button>
          )}
          <button
            type="button"
            onClick={(e) => {
              e?.preventDefault();
              e?.stopPropagation();
              onNext(e);
            }}
            className="flex items-center justify-center gap-2 rounded-lg bg-[#026857] px-4 sm:px-6 py-2.5 sm:py-3 text-xs sm:text-sm font-termina font-medium text-white transition-colors hover:bg-[#025247]"
          >
            Next
            <FiArrowRight className="h-4 w-4" />
          </button>
        </>
      ) : (
        <button
          type="button"
          onClick={(e) => {
            e?.preventDefault();
            e?.stopPropagation();
            onFindMatches(e);
          }}
          disabled={!canProceed}
          className="flex items-center justify-center gap-2 rounded-lg bg-[#026857] px-4 sm:px-6 py-2.5 sm:py-3 text-xs sm:text-sm font-termina font-medium text-white transition-colors hover:bg-[#025247] disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Find Matches
        </button>
      )}
    </div>
  );
};

